import {gql} from '@apollo/client'

export const GET_STATES_EU = gql`
  query allStates {
    allStates {
      edges {
        node {
          id
          name
          code
        }
      }
    }
  }
`

export const GET_ALL_STATES_EU_LIST = gql`
  query allStatesList {
    allStatesList {
      id
      name
      code
    }
  }
`
